const COOKIE_KEY_VENDOR_CONFIG = "FlexTeam-logger_vendor_config";
const DEVICE_ID_SEARCH_PARAMS_KEY = "amp_device_id";

export { COOKIE_KEY_VENDOR_CONFIG, DEVICE_ID_SEARCH_PARAMS_KEY };
//# sourceMappingURL=constants.mjs.map
